// extracted by mini-css-extract-plugin
export default {"close-button":"close-button--SLJdt","focus-visible":"focus-visible--YHERf","close-button__icon":"close-button__icon--oF0Ge"};